/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './ProjectSelection.css';
import amploflyLogo from '../../common/images/amplofly-logo.png';
import { verticalConfig } from './VerticalsConfig'; // Import config
import CacheStorage from '../../utils/CacheStorage';
import ApiServer from '../../common/js/ApiServices';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../DataManagement/Api'; // Using standard axios instance for quick client fetch

class ProjectSelection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'projects', // 'projects' or 'verticals'
            currentStep: 0, // 0: Client, 1: AmpProject, 2: CapProject, 3: KPIs
            loading: true,

            // Data Lists
            clients: [], // Companies
            allBenchmarkingProjects: [], // Full list of projects
            // clientProjects (filtered) will be derived or stored

            capabilityProjects: [],
            kpiList: [],

            // Manual Selections
            selectedClient: null,
            selectedAmpProject: null,
            selectedCapProject: null,
            selectedKpis: [], // Array of IDs

            // Search/Filter (Optional enhancement)
            clientSearch: '',
            projectSearch: '',
            capabilitySearch: '',
            kpiSearch: '',

            // Save Vertical Feature
            showSaveModal: false,
            verticalName: '',
            savedVerticals: [],
            savingVertical: false,
        };
        this.apiServer = new ApiServer(true);
    }

    handleSearchChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    componentDidMount() {
        // GUARD: Only allow Super Admin
        const userEmail = CacheStorage.getItem("userEmail") || sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail");
        if (!userEmail || userEmail.toLowerCase() !== "superadmin@amplo.com") {

            // Optionally check for employee to decide /dashboard vs /admin-dashboard, but /dashboard is safe fallback
            const isEmployee = CacheStorage.getItem("userType") && CacheStorage.getItem("userType") !== "1" && CacheStorage.getItem("userType") !== "2";
            if (isEmployee) {
                this.props.history.push("/admin-dashboard");
            } else {
                this.props.history.push("/module-hub");
            }
            return;
        }

        this.fetchData();
        this.fetchSavedVerticals();
    }

    fetchData = async () => {
        this.setState({ loading: true });
        const userEmail = sessionStorage.getItem("userEmail");
        const isAdmin = userEmail && userEmail.toLowerCase() === "superadmin@amplo.com";



        // API Endpoint for Projects (Benchmarking)
        const projectUrl = isAdmin ? '/admin/global-projects' : '/client-projects';

        try {
            // Parallel Fetch: Clients (for Admin) & Projects
            const promises = [
                this.apiServer.SendRequest({ method: 'GET', url: projectUrl }),
            ];

            // Only fetch clients for admin (or everyone if we want consistency)
            // Using standard axios 'api' for getAllCompanies to easily pass headers
            const headers = {
                "x-user-id": localStorage.getItem("UserId") || "",
                "x-tenant-schema": "Amplo111",
                "x-user-email": sessionStorage.getItem("userEmail") || "",
            };



            // If isAdmin, we fetch ALL companies using the endpoint we fixed
            // If not admin, we might skip this or fetch assigned company.
            // For now, assuming this screen upgrade is primarily for the Super Admin workflow requested.
            let clientsRes = [];
            if (isAdmin) {
                const res = await api.get("/getAllCompanies", { headers });
                clientsRes = res.data.data || [];
            } else {
                // For non-admin, we might want to just load their assigned company into 'clients' so Step 0 works seamlessly?
                // Or we could auto-skip Step 0. But let's keep it uniform for now.
                // We can fetch the single company using the same endpoint (it returns just 1 if not admin/overridden)
                const res = await api.get("/getAllCompanies", { headers });
                clientsRes = res.data.data || [];
            }

            const [projectRes] = await Promise.all(promises);



            // Helper to parse response if string
            const parseRes = (res) => {
                if (typeof res === 'string') {
                    try { return JSON.parse(res); } catch (e) { return res; }
                }
                return res;
            };

            const pRes = parseRes(projectRes);

            // Initialize projects, clear others
            this.setState({
                clients: clientsRes,
                allBenchmarkingProjects: (pRes.status === 'Success' || pRes.success === true) ? (pRes.data || []) : [],
                capabilityProjects: [],
                kpiList: [],
                loading: false
            }, () => {
                // Auto-select client if only one exists (e.g. for Normal User)
                if (this.state.clients.length === 1 && !isAdmin) {
                    this.selectClient(this.state.clients[0]);
                    // Optionally auto-advance? Let's let them see it for confirmation.
                }
            });

        } catch (error) {

            toast.error("Failed to load project data. Please refresh.");
            this.setState({ loading: false });
        }
    };

    fetchCapabilityProjects = (ampProjectId) => {
        // ALWAYS use the dependent linkage endpoint to ensure we only show linked projects.
        // This fixes the issue where Admins were seeing the global list instead of the filtered list.
        const url = `/GetCapabilityModelProjectLinkageWithAmpProjectName/${ampProjectId}`;

        this.setState({ loadingCapabilities: true });

        this.apiServer.SendRequest({
            method: 'GET',
            url: url,
            authentication: true,
        }).then((data) => {


            let capProjects = [];
            if (Array.isArray(data)) {
                capProjects = data;
            } else if (data.data) {
                capProjects = data.data;
            } else {
                try {
                    const parsed = JSON.parse(data);
                    capProjects = parsed.data || parsed;
                } catch (e) {
                    capProjects = [];
                }
            }

            this.setState({
                capabilityProjects: Array.isArray(capProjects) ? capProjects : [],
                loadingCapabilities: false
            });
        }).catch((error) => {

            this.setState({
                capabilityProjects: [],
                loadingCapabilities: false
            });
        });
    }

    fetchKpis = () => {
        // If we already have KPIs loaded, skip (unless we want to force refresh)
        if (this.state.kpiList.length > 0) return;

        // Use the dynamic list endpoint for all users to ensure consistent data with KpiSetting
        const url = '/getDynamicKpiListByKpiSet';

        this.setState({ loadingKpis: true });

        this.apiServer.SendRequest({
            method: 'GET',
            url: url,
            authentication: true,
        }).then((data) => {


            let kpis = [];
            if (Array.isArray(data)) {
                kpis = data;
            } else if (data.data) {
                kpis = data.data;
            } else {
                try {
                    const parsed = JSON.parse(data);
                    kpis = parsed.data || parsed;
                } catch (e) {
                    kpis = [];
                }
            }

            this.setState({
                kpiList: Array.isArray(kpis) ? kpis : [],
                loadingKpis: false
            });
        }).catch((error) => {

            this.setState({
                kpiList: [],
                loadingKpis: false
            });
        });
    }

    handleTabChange = (tab) => {
        this.setState({ activeTab: tab });
    };

    // Stepper Navigation
    nextStep = () => {
        const { currentStep, selectedClient, selectedAmpProject } = this.state;

        // Validation
        if (currentStep === 0 && !selectedClient) {
            toast.warn("Please select a Client.");
            return;
        }
        if (currentStep === 1 && !selectedAmpProject) {
            toast.warn("Please select an AmpMarking Project.");
            return;
        }

        this.setState(prevState => ({ currentStep: prevState.currentStep + 1 }));
    };

    prevStep = () => {
        this.setState(prevState => ({ currentStep: prevState.currentStep - 1 }));
    };

    renderStepper = () => {
        const { currentStep } = this.state;
        return (
            <div className="stepper-container">
                <div className={`step-item ${currentStep >= 0 ? 'active' : ''} ${currentStep > 0 ? 'completed' : ''}`}>
                    <div className="step-circle">{currentStep > 0 ? <i className="fas fa-check"></i> : '1'}</div>
                    <div className="step-label">Client</div>
                </div>
                <div className="step-line"></div>
                <div className={`step-item ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`}>
                    <div className="step-circle">{currentStep > 1 ? <i className="fas fa-check"></i> : '2'}</div>
                    <div className="step-label">Benchmarking</div>
                </div>
                <div className="step-line"></div>
                <div className={`step-item ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`}>
                    <div className="step-circle">{currentStep > 2 ? <i className="fas fa-check"></i> : '3'}</div>
                    <div className="step-label">Capability</div>
                </div>
                {/* <div className="step-line"></div>
                <div className={`step-item ${currentStep >= 3 ? 'active' : ''}`}>
                    <div className="step-circle">4</div>
                    <div className="step-label">KPIs</div>
                </div> */}
            </div>
        );
    };

    renderStepContent = () => {
        const { currentStep, clients, allBenchmarkingProjects, capabilityProjects, kpiList, selectedClient, selectedAmpProject, selectedCapProject, selectedKpis, clientSearch, projectSearch, capabilitySearch, kpiSearch } = this.state;

        switch (currentStep) {
            case 0: // Client Selection
                const filteredClients = clients.filter(c =>
                    c.name?.toLowerCase().includes(clientSearch.toLowerCase())
                );
                return (
                    <div className="step-content animate-slide-up">
                        <div className="step-header">
                            <h3>Select Client</h3>
                            <p>Choose the client organization context.</p>
                        </div>
                        <div className="search-container">
                            <i className="fas fa-search search-icon"></i>
                            <input
                                type="text"
                                name="clientSearch"
                                placeholder="Search clients..."
                                value={clientSearch}
                                onChange={this.handleSearchChange}
                                className="search-input"
                            />
                        </div>
                        <div className="cards-grid custom-scrollbar">
                            {filteredClients.map(client => (
                                <div
                                    key={client.company_id}
                                    className={`selection-card-item ${selectedClient?.company_id === client.company_id ? 'selected' : ''}`}
                                    onClick={() => this.selectClient(client)}
                                >
                                    <div className="card-icon"><i className="fas fa-building"></i></div>
                                    <div className="card-info">
                                        <h4>{client.name}</h4>
                                        <p style={{ fontSize: '0.8rem', color: '#666' }}>{client.industry_name || 'Industry N/A'}</p>
                                    </div>
                                    {selectedClient?.company_id === client.company_id && <div className="selected-overlay"><i className="fas fa-check"></i></div>}
                                </div>
                            ))}
                        </div>
                    </div>
                );

            case 1: // Benchmarking Project
                // FILTER projects by Selected Client's Company ID
                const clientProjects = allBenchmarkingProjects.filter(p => {
                    // Assuming projects have CompanyID. If not, we rely on name or admin logic, but ideally ID.
                    // Checking available fields from previous logs or typical schema.
                    // If p.CompanyID exists, use it.
                    // Fallback: If no company selected (shouldn't happen), show all?
                    if (selectedClient && p.CompanyID) {
                        return String(p.CompanyID) === String(selectedClient.company_id);
                    }
                    return true;
                });

                const filteredAmpProjects = clientProjects.filter(p =>
                    p.BMProjectName?.toLowerCase().includes(projectSearch.toLowerCase())
                );
                return (
                    <div className="step-content animate-slide-up">
                        <div className="step-header">
                            <h3>Select Benchmarking Project</h3>
                            <p>Choose the benchmarking project for {selectedClient ? selectedClient.name : 'client'}.</p>
                        </div>
                        <div className="search-container">
                            <i className="fas fa-search search-icon"></i>
                            <input
                                type="text"
                                name="projectSearch"
                                placeholder="Search projects..."
                                value={projectSearch}
                                onChange={this.handleSearchChange}
                                className="search-input"
                            />
                        </div>
                        <div className="cards-grid custom-scrollbar">
                            {filteredAmpProjects.length > 0 ? filteredAmpProjects.map(proj => (
                                <div
                                    key={proj.BMProjectID}
                                    className={`selection-card-item ${selectedAmpProject?.BMProjectID === proj.BMProjectID ? 'selected' : ''}`}
                                    onClick={() => this.selectAmpProject(proj)}
                                >
                                    <div className="card-icon"><i className="fas fa-chart-line"></i></div>
                                    <div className="card-info">
                                        <h4>{proj.BMProjectName}</h4>
                                    </div>
                                    {selectedAmpProject?.BMProjectID === proj.BMProjectID && <div className="selected-overlay"><i className="fas fa-check"></i></div>}
                                </div>
                            )) : (
                                <div className="no-data-message">
                                    <p>No projects found for this client.</p>
                                </div>
                            )}
                        </div>
                    </div>
                );
            case 2:
                // Filter by Search
                const filteredCapProjects = capabilityProjects.filter(p => {
                    return p.ProjectName?.toLowerCase().includes(capabilitySearch.toLowerCase());
                });

                return (
                    <div className="step-content animate-slide-up">
                        <div className="step-header">
                            <h3>Select Capability Project</h3>
                            <p>Choose the capability modeling project for decomposition (Optional).</p>
                        </div>
                        <div className="search-container">
                            <i className="fas fa-search search-icon"></i>
                            <input
                                type="text"
                                name="capabilitySearch"
                                placeholder="Search capability projects..."
                                value={capabilitySearch}
                                onChange={this.handleSearchChange}
                                className="search-input"
                            />
                        </div>
                        <div className="cards-grid custom-scrollbar">
                            {filteredCapProjects.length > 0 ? (
                                filteredCapProjects.map(proj => (
                                    <div
                                        key={proj.DecompositionProjectID}
                                        className={`selection-card-item ${selectedCapProject?.DecompositionProjectID === proj.DecompositionProjectID ? 'selected' : ''}`}
                                        onClick={() => this.selectCapProject(proj)}
                                    >
                                        <div className="card-icon success"><i className="fas fa-project-diagram"></i></div>
                                        <div className="card-info">
                                            <h4>{proj.ProjectName}</h4>
                                        </div>
                                        {selectedCapProject?.DecompositionProjectID === proj.DecompositionProjectID && <div className="selected-overlay"><i className="fas fa-check"></i></div>}
                                    </div>
                                ))
                            ) : (
                                <div className="no-data-message">
                                    <p>No capability projects found for the selected benchmarking project.</p>
                                </div>
                            )}
                        </div>
                    </div>
                );
            // case 3:
            //     // Filter KPIs by the Capabilities present in the selected Capability Project
            //     const filteredKpis = kpiList.filter(k => {
            //         const displayName = k.KPIName || k.KPITitle || "";
            //         const matchesSearch = displayName.toLowerCase().includes(kpiSearch.toLowerCase());

            //         // Filter: KPI's CapabilityID (Name) must match one of the Project's Capabilities
            //         // We check against ProcessLevel1Title (primary) or Name/ProcessLevel1Name in projectCapabilities
            //         const matchesProject = this.state.projectCapabilities.length > 0
            //             ? this.state.projectCapabilities.some(cap => {
            //                 const capName = (cap.ProcessLevel1Title || cap.Name || cap.ProcessLevel1Name || cap.DecompositionProcessLevel1Name || "").trim().toLowerCase();
            //                 const kpiCapName = (k.CapabilityID || "").trim().toLowerCase();
            //                 // Strict matching: 
            //                 // 1. If KPI has NO CapabilityID, show it (Generic).
            //                 // 2. If KPI HAS CapabilityID, it must match one of the Project's Capabilities.
            //                 if (!kpiCapName) return true;

            //                 return capName && (capName === kpiCapName);
            //             })
            //             : true;
            //         return matchesSearch && matchesProject;
            //     });

            //     return (
            //         <div className="step-content animate-slide-up">
            //             <div className="step-header">
            //                 <h3>Select KPIs</h3>
            //                 <p>Choose the Key Performance Indicators to track.</p>
            //             </div>
            //             <div className="search-container">
            //                 <i className="fas fa-search search-icon"></i>
            //                 <input
            //                     type="text"
            //                     name="kpiSearch"
            //                     placeholder="Search KPIs..."
            //                     value={kpiSearch}
            //                     onChange={this.handleSearchChange}
            //                     className="search-input"
            //                 />
            //             </div>
            //             <div className="kpi-list-container custom-scrollbar">
            //                 {this.state.loadingKpis || this.state.loadingProjectCaps ? (
            //                     <div className="loading-spinner">Loading KPIs...</div>
            //                 ) : filteredKpis.length > 0 ? (
            //                     filteredKpis.map(kpi => {
            //                         const isSelected = selectedKpis.some(k => k.KPIID === kpi.KPIID);
            //                         return (
            //                             <div
            //                                 key={kpi.KPIID}
            //                                 className={`kpi-list-item ${isSelected ? 'selected' : ''}`}
            //                                 onClick={() => this.toggleKpi(kpi)}
            //                             >
            //                                 <div className="kpi-info">
            //                                     <h4>{kpi.KPIName || kpi.KPITitle}</h4>
            //                                     <p>{kpi.Description || 'No description available.'}</p>
            //                                     <small className="text-muted">Capability: {kpi.CapabilityID}</small>
            //                                 </div>
            //                                 <div className="kpi-check">
            //                                     {isSelected ? <i className="fas fa-check-circle text-success"></i> : <i className="far fa-circle text-muted"></i>}
            //                                 </div>
            //                             </div>
            //                         );
            //                     })
            //                 ) : (
            //                     <div className="no-data-message">
            //                         <p>No KPIs found for the selected capability project.</p>
            //                     </div>
            //                 )}
            //             </div>
            //         </div>
            //     );
            default:
                return null;
        }
    };

    fetchProjectCapabilities = (decompositionProjectId) => {
        this.setState({ loadingProjectCaps: true, projectCapabilities: [] });
        this.apiServer.SendRequest({
            method: 'GET',
            url: `/capability-mapping-modeling-project-capability/${decompositionProjectId}`,
            authentication: true,
        }).then((data) => {

            let caps = [];
            if (Array.isArray(data)) {
                caps = data;
            } else if (data.data) {
                caps = data.data;
            }
            this.setState({ projectCapabilities: caps, loadingProjectCaps: false });
        }).catch((error) => {

            this.setState({ loadingProjectCaps: false });
        });
    }

    // Manual Selection Handlers
    selectClient = (client) => {
        this.setState({
            selectedClient: client,
            selectedAmpProject: null, // Reset downstream
            selectedCapProject: null,
            selectedKpis: [],
            capabilityProjects: [],
            projectCapabilities: []
        });
    }

    selectAmpProject = (project) => {
        this.setState({
            selectedAmpProject: project,
            selectedCapProject: null,
            selectedKpis: [],
            capabilityProjects: [], // Clear previous
            projectCapabilities: [] // Clear previous caps
        }, () => {
            // Fetch dependent capability projects
            if (project && project.BMProjectID) {
                this.fetchCapabilityProjects(project.BMProjectID);
            }
        });
    };

    selectCapProject = (project) => {
        this.setState({
            selectedCapProject: project,
            selectedKpis: [],
            projectCapabilities: []
        }, () => {
            // Fetch KPIs (currently lazy loading global list)
            this.fetchKpis();
            // Fetch Capabilities for this project to filter the KPIs
            if (project && project.DecompositionProjectID) {
                this.fetchProjectCapabilities(project.DecompositionProjectID);
            }
        });
    };

    toggleKpi = (kpi) => {
        const { selectedKpis } = this.state;
        const exists = selectedKpis.find(k => k.KPIID === kpi.KPIID);
        let newSelection;
        if (exists) {
            newSelection = selectedKpis.filter(k => k.KPIID !== kpi.KPIID);
        } else {
            newSelection = [...selectedKpis, kpi];
        }
        this.setState({ selectedKpis: newSelection });
    };

    handleContinueManual = () => {
        const { selectedClient, selectedAmpProject, selectedCapProject, selectedKpis } = this.state;

        if (!selectedClient) {
            toast.warn("Please select a Client.");
            return;
        }
        if (!selectedAmpProject) {
            toast.warn("Please select an AmpMarking Project.");
            return;
        }

        // Open Save Modal instead of immediate redirect
        this.setState({ showSaveModal: true, verticalName: '' });
    };

    closeSaveModal = () => {
        this.setState({ showSaveModal: false });
    };

    handleVerticalNameChange = (e) => {
        this.setState({ verticalName: e.target.value });
    };

    saveVertical = () => {
        const { verticalName, selectedClient, selectedAmpProject, selectedCapProject, selectedKpis } = this.state;

        if (!verticalName.trim()) {
            toast.warn("Please enter a name for the vertical.");
            return;
        }

        this.setState({ savingVertical: true });

        const payload = {
            title: verticalName,
            clientID: selectedClient.company_id,
            clientName: selectedClient.name,
            ampProjectID: selectedAmpProject.BMProjectID,
            ampProjectName: selectedAmpProject.BMProjectName,
            capProjectID: selectedCapProject.DecompositionProjectID,
            capProjectName: selectedCapProject.ProjectName,
            kpis: selectedKpis.map(k => ({ id: k.KPIID, name: k.KPIName || k.KPITitle }))
        };

        this.apiServer.SendRequest({
            method: 'POST',
            url: '/save-vertical', // Assuming this endpoint
            data: payload,
            authentication: true,
        }).then((res) => {


            toast.success("Vertical saved successfully!");
            this.setState({ savingVertical: false, showSaveModal: false });

            // Proceed to Dashboard
            this.saveAndRedirect({
                type: 'manual',
                client: this.state.selectedClient,
                ampProject: selectedAmpProject,
                capProject: selectedCapProject,
                kpis: selectedKpis
            });
        }).catch((err) => {

            toast.error("Failed to save vertical, but proceeding to dashboard.");
            this.setState({ savingVertical: false, showSaveModal: false });

            this.saveAndRedirect({
                type: 'manual',
                ampProject: selectedAmpProject,
                capProject: selectedCapProject,
                kpis: selectedKpis
            });
        });
    };

    fetchSavedVerticals = () => {
        this.apiServer.SendRequest({
            method: 'GET',
            url: '/get-user-verticals', // Assuming this endpoint
            authentication: true,
        }).then((data) => {

            let verticals = [];
            if (Array.isArray(data)) {
                verticals = data;
            } else if (data.data) {
                verticals = data.data;
            } else {
                // Try parsing
                try {
                    const parsed = JSON.parse(data);
                    verticals = parsed.data || parsed;
                } catch (e) { verticals = []; }
            }
            this.setState({ savedVerticals: Array.isArray(verticals) ? verticals : [] });
        }).catch(err => {

            // Fallback to empty or config if desired, but user wants "what ever user selects"
            this.setState({ savedVerticals: [] });
        });
    };

    skipSaveAndProceed = () => {
        const { selectedAmpProject, selectedCapProject, selectedKpis } = this.state;
        this.setState({ showSaveModal: false });
        this.saveAndRedirect({
            type: 'manual',
            client: this.state.selectedClient,
            ampProject: selectedAmpProject,
            capProject: selectedCapProject,
            kpis: selectedKpis
        });
    };

    // Vertical Selection Handler
    handleSelectVertical = (vertical) => {
        const { kpiList } = this.state;
        let hydratedKpis = [];

        if (Array.isArray(vertical.kpis)) {
            if (vertical.kpis.length > 0 && typeof vertical.kpis[0] === 'object') {
                hydratedKpis = vertical.kpis;
            } else {
                // Map IDs to objects
                // Ensure type safety for ID comparison
                hydratedKpis = kpiList.filter(k => vertical.kpis.some(id => String(id) === String(k.KPIID)));
            }
        }

        this.saveAndRedirect({
            type: 'vertical',
            verticalId: vertical.id,
            verticalTitle: vertical.title,
            client: vertical.client,
            ampProject: vertical.ampMarkingProject,
            capProject: vertical.capabilityProject,
            kpis: hydratedKpis
        });
    };

    saveAndRedirect = (data) => {
        // Enforce Client persistence from State if not explicitly passed
        // This ensures the Step 0 selection is carried over
        const finalData = {
            ...data,
            client: data.client || this.state.selectedClient
        };

        // Save to Session Storage
        sessionStorage.setItem('projectSelection', JSON.stringify(finalData));

        // Global Context Setting (Phase 2 Requirement)
        // Ensure "Right Data" is loaded by downstream components
        if (finalData.capProject && finalData.capProject.DecompositionProjectID) {
            CacheStorage.setItem('DecompositionProjectID', finalData.capProject.DecompositionProjectID);
            CacheStorage.setItem('CapabilityProjectName', finalData.capProject.ProjectName);
        } else {
            // Clear if skipped to avoid stale data
            CacheStorage.removeItem('DecompositionProjectID');
            CacheStorage.removeItem('CapabilityProjectName');
        }

        if (finalData.ampProject && finalData.ampProject.BMProjectID) {
            CacheStorage.setItem('benchmark_project_id', finalData.ampProject.BMProjectID);
            CacheStorage.setItem('AmpProjectName', finalData.ampProject.BMProjectName);
        }

        // Redirect to Dashboard
        setTimeout(() => {
            this.props.history.push('/dashboard');
        }, 1000);
    };

    render() {
        const { activeTab, loading, clientProjects, capabilityProjects, kpiList, selectedClient, selectedAmpProject, selectedCapProject, selectedKpis, showSaveModal, verticalName, savedVerticals } = this.state;

        if (loading) {
            return (
                <div className="project-selection-container">
                    <div className="loader-container">
                        <div className="spinner"></div>
                        <p>Loading your projects...</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="project-selection-container">
                <ToastContainer position="top-right" autoClose={3000} />

                {/* Save Vertical Modal */}
                {showSaveModal && (
                    <div className="modal-overlay">
                        <div className="modal-content animate-slide-up project-selection-modal">
                            <h3>Save Vertical Context</h3>
                            <p>Do you want to save this selection as a Vertical for quick access later?</p>

                            <div className="form-group">
                                <label>Vertical Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="e.g. My Pharma Benchmark"
                                    value={verticalName}
                                    onChange={this.handleVerticalNameChange}
                                />
                            </div>

                            <div className="modal-actions">
                                <button className="btn-outline-secondary" onClick={this.skipSaveAndProceed}>
                                    No, just Dashboard
                                </button>
                                <button className="btn-primary-elegant" onClick={this.saveVertical} disabled={this.state.savingVertical}>
                                    {this.state.savingVertical ? 'Saving...' : 'Yes, Save & Proceed'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div className="selection-card animate-fade-in">
                    {/* Header */}
                    <div className="selection-header">
                        <img src={amploflyLogo} alt="AmploFly Logo" className="header-logo" />
                        <h2>Welcome to AmploFly</h2>
                        <p>Please select your working context to proceed to the dashboard.</p>
                    </div>

                    {/* Tabs */}
                    <div className="tabs-container">
                        <button
                            className={`tab-btn ${activeTab === 'projects' ? 'active' : ''}`}
                            onClick={() => this.handleTabChange('projects')}
                        >
                            <i className="fas fa-list-ul"></i> Choose from Projects
                        </button>
                        <button
                            className={`tab-btn ${activeTab === 'verticals' ? 'active' : ''}`}
                            onClick={() => this.handleTabChange('verticals')}
                        >
                            <i className="fas fa-th-large"></i> Choose from Verticals
                        </button>
                    </div>

                    {/* Content */}
                    <div className="tab-content">
                        {activeTab === 'projects' ? (
                            <div className="wizard-container">
                                {this.renderStepper()}
                                <div className="step-wrapper">
                                    {this.renderStepContent()}
                                </div>
                                <div className="wizard-actions">
                                    <button
                                        className="btn-outline-elegant"
                                        onClick={this.prevStep}
                                        disabled={this.state.currentStep === 0}
                                    >
                                        Back
                                    </button>

                                    {this.state.currentStep < 2 ? (
                                        <button
                                            className="btn-primary-elegant"
                                            onClick={this.nextStep}
                                        >
                                            Next <i className="fas fa-arrow-right ml-2"></i>
                                        </button>
                                    ) : (
                                        <button
                                            className="btn-primary-elegant"
                                            onClick={this.handleContinueManual}
                                        // Disabled check removed to allow empty KPIs
                                        >
                                            Finish & Dashboard
                                        </button>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="verticals-grid animate-slide-up">
                                {savedVerticals.length > 0 ? (
                                    savedVerticals.map(vertical => (
                                        <div key={vertical.id || Math.random()} className="vertical-card" onClick={() => this.handleSelectVertical(vertical)}>
                                            <div className="card-header-bg"></div>
                                            <div className="vertical-content">
                                                <h3>{vertical.title}</h3>
                                                <p className="description">{vertical.description || "User saved vertical"}</p>

                                                <div className="details-list">
                                                    <div className="detail-row">
                                                        <strong>Client:</strong>
                                                        <span>{vertical.client?.name || "N/A"}</span>
                                                    </div>
                                                    <div className="detail-row">
                                                        <strong>Benchmarking:</strong>
                                                        <span>{vertical.ampMarkingProject?.BMProjectName || vertical.ampMarkingProject?.name}</span>
                                                    </div>
                                                    <div className="detail-row">
                                                        <strong>Capability:</strong>
                                                        <span>{vertical.capabilityProject?.ProjectName || vertical.capabilityProject?.name}</span>
                                                    </div>
                                                    <div className="detail-row">
                                                        <strong>KPIs:</strong>
                                                        <span>
                                                            {vertical.kpis?.length || 0} Saved
                                                            {vertical.kpis && vertical.kpis.length > 0 && vertical.kpis[0].name ? ` (${vertical.kpis[0].name}${vertical.kpis.length > 1 ? '...' : ''})` : ''}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="select-btn">Select <i className="fas fa-arrow-right"></i></div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-data-message" style={{ width: '100%', textAlign: 'center' }}>
                                        <p>No saved verticals found. Create one by finishing a project selection path.</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(ProjectSelection);
